const ru = {
  showMore: 'Show more',
  showLess: 'Show less',
};
export default ru;
